module.exports = __webpack_public_path__ + "assets/img/7.fcc29034.png";